import { Icon } from 'components/Icon';
import SmallLabel from 'components/UI/Labels/SmallLabel';
import TouchablePanel from 'components/UI/Panel/TouchablePanel';
import { toSentenceCase } from 'modules/utils/StringUtils';
import { Color, gray, textDark } from 'modules/styles/colors';
import React from 'react';
import styled from 'styled-components';

interface Props {
  children: React.ReactNode;
  disabled?: boolean;
  onPress: () => void;
  iconName?: string;
}

const StyledTouchablePanel = styled(TouchablePanel)`
  align-items: center;
  border-color: ${props => (props.disabled ? null : gray)};
  display: flex;
  flex-direction: row;
  padding: 6px 10px 6px 10px;
  cursor: ${props => (props.disabled ? 'initial' : 'pointer')};
`;

const StyledLabel = styled(SmallLabel)`
  color: ${props => (props.disabled ? Color.textLight : textDark)};
  line-height: 24px;
  padding-left: ${props => (props.leftPadding ? 10 : 0)}px;
`;

const PanelButton = (props: Props) => (
  <StyledTouchablePanel onPress={props.onPress} disabled={props.disabled}>
    {props.iconName && (
      <Icon name={props.iconName} size={24} color={props.disabled ? Color.textLight : textDark} />
    )}
    <StyledLabel leftPadding={!!props.iconName}>{toSentenceCase(props.children)}</StyledLabel>
  </StyledTouchablePanel>
);

PanelButton.defaultProps = {
  iconName: null
};

export default PanelButton;
